import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0584 = React.lazy(() => import('./symbols/0584_movie_film_cinema'));
const Symbol0585 = React.lazy(() => import('./symbols/0585_hd_movie_video_camera_recording'));
const Symbol0586 = React.lazy(() => import('./symbols/0586_movie_video_camera_recording'));
const Symbol0587 = React.lazy(() => import('./symbols/0587_movie_video_cinema_flm'));
const Symbol0588 = React.lazy(() => import('./symbols/0588_play_movie_video_cinema_flm'));
const Symbol0589 = React.lazy(() => import('./symbols/0589_ticket_movie_cinema'));
const Symbol0590 = React.lazy(() => import('./symbols/0590_movie_recording_play_director_cut'));
const Symbol0591 = React.lazy(() => import('./symbols/0591_presentation_video_play_beamer'));
const Symbol0592 = React.lazy(() => import('./symbols/0592_tv_televison_movie_news'));
const Symbol0593 = React.lazy(() => import('./symbols/0593_video_play_youtube'));
const Symbol0594 = React.lazy(() => import('./symbols/0594_beamer_presentation_projector'));

export interface IProps {}

const Video: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0584_movie_film_cinema" symbol={<Symbol0584 />} />
      <LazySymbol id="0585_hd_movie_video_camera_recording" symbol={<Symbol0585 />} />
      <LazySymbol id="0586_movie_video_camera_recording" symbol={<Symbol0586 />} />
      <LazySymbol id="0587_movie_video_cinema_flm" symbol={<Symbol0587 />} />
      <LazySymbol id="0588_play_movie_video_cinema_flm" symbol={<Symbol0588 />} />
      <LazySymbol id="0589_ticket_movie_cinema" symbol={<Symbol0589 />} />
      <LazySymbol id="0590_movie_recording_play_director_cut" symbol={<Symbol0590 />} />
      <LazySymbol id="0591_presentation_video_play_beamer" symbol={<Symbol0591 />} />
      <LazySymbol id="0592_tv_televison_movie_news" symbol={<Symbol0592 />} />
      <LazySymbol id="0593_video_play_youtube" symbol={<Symbol0593 />} />
      <LazySymbol id="0594_beamer_presentation_projector" symbol={<Symbol0594 />} />
    </>
  );
});

Video.displayName = 'Video';

export default Video;
